import * as yup from "yup";
import { ContactType } from "../../enums/ContactType";
import { Max, Validation } from "../../utils/Validation.utils";
export const PriorityNoteInitialValues = {
    note: "",
    contactType: ContactType.NONE,
    contactReason: undefined,
    contactOutcome: undefined
};
export const PriorityNoteSchema = yup.object().shape({
    note: yup.string().max(Max.Note, Validation.Max),
    contactType: yup.string().nullable(),
    contactReason: yup
        .string()
        .nullable()
        .max(Max.ContactIntent, Validation.Max),
    contactOutcome: yup
        .string()
        .nullable()
        .max(Max.ContactOutcome, Validation.Max)
});
